import {
  setCookie,
  getCookie,
  hasCookie,
  HAS_ALO_AUTH_TOKEN_STATE_COOKIE,
  ALO_AUTH_TOKEN_STATE,
  sign_out_cookie_deletion
} from 'components_v2/common'

export const signout_from_aloyoga = () => {
  const allFreePath = window.location.pathname === '/all-free'
  if (allFreePath) return
  if (!hasCookie('signout_from_aloyoga')) return

  const origin = window.location.origin
  const replaceString =
    origin && (origin.includes('qa.aloyoga') || origin.includes('dev.aloyoga'))
      ? ''
      : 'www.'
  const alo_yoga_multipass_host =
    origin && origin.includes('wellnessclub.')
      ? origin.replace('wellnessclub.', replaceString)
      : origin
  sign_out_cookie_deletion(`${alo_yoga_multipass_host}/account/logout`)
}

const ssoSignoutHandler = () => {
  try {
    const allFreePath = window.location.pathname === '/all-free'
    if (allFreePath) return
    if (
      hasCookie('signed_out_alo_migrated_user') &&
      HAS_ALO_AUTH_TOKEN_STATE_COOKIE
    ) {
      const signedOutUserDetailsCookie = getCookie(
        'signed_out_alo_migrated_user'
      )
      if (signedOutUserDetailsCookie) {
        const decodedSignedOutDetails = JSON.parse(
          decodeURIComponent(signedOutUserDetailsCookie)
        )
        const aloAuthTokenState = decodeURIComponent(
          getCookie(ALO_AUTH_TOKEN_STATE)
        )
        if (
          decodedSignedOutDetails.email ===
          aloAuthTokenState.split('"').join('')
        ) {
          sign_out_cookie_deletion(decodedSignedOutDetails.signOutUrl)
        }
      }
    } else if (
      !HAS_ALO_AUTH_TOKEN_STATE_COOKIE &&
      (hasCookie('_shopify_s') || hasCookie('_shopify_y'))
    ) {
      fetch(`/api/v2/alo_token_auth/check_session`, {
        method: 'POST',
        credentials: 'include'
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.refresh) {
            setCookie('awc_session_established', 'false', 1 / 24)
            window.location.reload()
          }
        })
        .catch((err) => {
          console.error('[alo_checker] Token verification failed:', err)
        })
    }
  } catch (err) {
    // swallow errors silently
  }
}

export default ssoSignoutHandler
